// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SaveTwoToneSvg from "@ant-design/icons-svg/es/asn/SaveTwoTone";
import AntdIcon from '../components/AntdIcon';

var SaveTwoTone = function SaveTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SaveTwoToneSvg
  }));
};

SaveTwoTone.displayName = 'SaveTwoTone';
export default React.forwardRef(SaveTwoTone);